package com.example.mystybag.remoteLogger

object RemoteLogger {

    const val TYPE_LOG          = 0x01 //messages from Logger.log
    const val TYPE_REST         = 0x02 //messages from HttpClient
    const val TYPE_EXCEPTION    = 0x04 //messages from LogHelper.logExceptionEvent
    const val TYPE_EVENT        = 0x08 //messages from LogHelper.logEvent
    const val TYPE_CUSTOM       = 0x10 //messages from RemoteLogger.log(...) calls
    const val TYPE_ALL          = 0xFF

    private var instance: RemoteLoggerImpl? = null

    var enabled: Boolean
        get() = instance != null
        set(value) {
            instance = if (value) RemoteLoggerImpl() else null
        }

    var walletID: Long?
        get() = instance?.walletID
        set(value) {
            instance?.walletID = value
        }

    var resourceID: String
        get() = instance?.resourceID ?: "-"
        set(value) {
            instance?.resourceID = value
        }


    var logLevel: Int
        get() = instance?.logLevel ?: TYPE_ALL
        set(value) {
            instance?.logLevel= value
        }

    fun log(ex: Exception) = instance?.log(ex)
    fun log(message: String, level: Int = TYPE_ALL) = instance?.log(message, level)
}

